import moment from 'moment-timezone';
import { FeatureFlags } from '@logz-pkg/enums';
import { sessionStateService } from '../state/session.state.service';
import { cacheProvider } from '../core/cache/cache.provider';

const EXPIRATION_TIME_AMOUNT = 14;
const EXPIRATION_TIME_UNIT = 'days';

const DEFAULT_SESSION_DURATION = moment.duration(24, 'hours').asMilliseconds();
const SESSION_REFRESH_INTERVAL = moment.duration(1, 'hour').asMilliseconds();
const INTERVAL_EXPIRATION_TIME =
  moment.duration(EXPIRATION_TIME_AMOUNT, EXPIRATION_TIME_UNIT).asMilliseconds() - DEFAULT_SESSION_DURATION;
const SETTINGS_CACHE_KEY = 'keepLoggedInToggle';

let intervalId: ReturnType<typeof setInterval> | null = null;

const getCacheKey = () => {
  return `${SETTINGS_CACHE_KEY}.${sessionStateService.session.get()?.userSession?.userId}`;
};

const isEnabled = () => {
  return (
    sessionStateService.session.get()?.featureFlags?.includes(FeatureFlags.KeepLoggedInToggle) === true &&
    cacheProvider.getPersistentTtl<boolean>(getCacheKey()) === true
  );
};

const clear = () => {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
};

const disableInterval = () => {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }

  cacheProvider.clearPersist(getCacheKey());
};

const startInterval = () => {
  cacheProvider.setPersistentTtl(getCacheKey(), true, INTERVAL_EXPIRATION_TIME);

  if (intervalId) clearInterval(intervalId);

  intervalId = setInterval(() => {
    if (!isEnabled()) {
      disableInterval();

      return;
    }

    sessionStateService.fetch({ fresh: true });
  }, SESSION_REFRESH_INTERVAL);
};

const init = () => {
  if (isEnabled()) startInterval();
};

export const keepLoggedInService = {
  init,
  clear,
  startInterval,
  disableInterval,
  get isActive() {
    return cacheProvider.getPersistentTtl<boolean>(getCacheKey()) ?? false;
  },
  expirationTimeAmount: EXPIRATION_TIME_AMOUNT,
  expirationTimeUnit: EXPIRATION_TIME_UNIT,
};
